import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-95f7b28e")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon" })
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(!_ctx.hasAccessToPinnedAssets ? 'div' : 'router-link'), {
    class: _normalizeClass(["link-to-pinned-assets", {
      'is-active': _ctx.isMyAssetsRoute,
      'is-disabled': !_ctx.hasAccessToPinnedAssets,
    }]),
    to: _ctx.toPinnedAssets,
    title: !_ctx.hasAccessToPinnedAssets ? 'Only registered users' : ''
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["class", "to", "title"]))
}